import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WheelchairComponent } from './wheelchair.component';
import { WheelchairHomeComponent } from './components/home/wheelchair-home.component';
import { WheelchairAttachedComponent } from './components/attached/wheelchair-attached.component';
import { WheelchairRankingComponent } from './components/ranking/list/wheelchair-ranking.component';
import { WheelchairRankingClassifComponent } from './components/ranking/classification/wheelchair-ranking-classif.component';
import { WheelchairRankingHistoryComponent } from './components/history/wheelchair-ranking-history.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: WheelchairComponent,
        children: [
            { path: 'home', component: WheelchairHomeComponent },
            {
                path: 'tournament',
                loadChildren: () => import('../tournament/tournament.module').then((m) => m.TournamentModule),
            },
            { path: 'ranking-2', loadChildren: () => import('../ranking/ranking.module').then((m) => m.RankingModule) },
            { path: 'ranking', component: WheelchairRankingComponent },
            { path: 'history', component: WheelchairRankingHistoryComponent },
            {
                path: 'ranking-classif/:rankingId',
                component: WheelchairRankingClassifComponent,
            },
            {
                path: 'attached/:sessionType',
                component: WheelchairAttachedComponent,
            },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class WheelchairRoutingModule {}
